import Calendar from './calendar';
import './styles/index.scss';
export { Calendar };
export default Calendar;
